export class EventDispatch {
  callBacks = {};

  fireEvent(eventName: string, ...rest) {
    const eventHandlers = this.callBacks[eventName];
    if (!eventHandlers) {
      return;
    }
    eventHandlers.forEach(function (handler) {
      handler.apply(null, rest);
    });
  }

  on(eventName, callback, thisArg?) {

    this.callBacks[eventName] = this.callBacks[eventName] || [];

    callback = thisArg ? callback.bind(thisArg) : callback;

    this.callBacks[eventName].push(callback);

    return () => {
      const index = this.callBacks[eventName].indexOf(callback);
      this.callBacks[eventName].splice(index, 1);
    };
  }

  dispose() {
    this.callBacks = null;
  }
}




// WEBPACK FOOTER //
// ./src/app/event-dispatch.ts